import {
  BackButton,
  Container,
  LoadingIndicator,
  Page,
  PageTitle,
  useToaster,
} from '@foxtrotplatform/developer-platform-common-ui-component-lib';
import { useOrganization } from '@foxtrotplatform/platform-micro-site-core';
import { Button } from '@windmill/react-ui';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { SolutionInputFields } from '../../common/api/models/solution';
import { registerSolution } from '../../common/api/solution';
import { requiredFieldsFilled } from '../../common/utilities/requiredFieldsFilled';
import { SolutionRegistrationInput } from './SolutionRegistrationInput';
import { solutionTabs } from './solutionSteps';
import { SolutionSubmissionTabs } from './SolutionSubmissionTabs';

export const CreateSolution: React.FunctionComponent = () => {
  const { addToast } = useToaster();
  const navigate = useNavigate();
  const { currentOrg } = useOrganization();
  const [isRegistering, setIsRegistering] = useState(false);

  const { control, handleSubmit, register, watch, formState } =
    useForm<SolutionInputFields>({
      mode: 'onBlur',
      defaultValues: {
        displayName: '',
        shortDescription: '',
        categories: [],
        visibility: {
          isMarketplaceVisible: false,
        },
        version: '',
      },
    });
  const watchAll = watch();
  const required = ['displayName', 'shortDescription', 'categories', 'version'];
  const notFullyFilledOut = !requiredFieldsFilled(watchAll, required);
  const onSubmit = async (data: SolutionInputFields) => {
    setIsRegistering(true);

    if (currentOrg && currentOrg.id) {
      try {
        const { solutionId } = await registerSolution(currentOrg.id, data);
        addToast({
          title: 'Success!',
          message:
            'Your solution has been registered! You can continue to Define a Solution or do that later.',
          type: 'success',
        });
        navigate(`/solution/${solutionId}`);
      } catch {
        addToast({
          message: 'Failed to register solution.',
          type: 'error',
        });
        setIsRegistering(false);
      }
    }

    setIsRegistering(false);
  };

  return (
    <Page>
      <Container size="medium">
        <div className="w-full flex flex-col justify-between items-center mb-os1-spacing">
          <div className="w-full flex flex-row items-center gap-x-3">
            <BackButton />
            <PageTitle>Register a Solution</PageTitle>
          </div>
          <div className="w-full mt-6">
            <SolutionSubmissionTabs
              activeTab="register"
              disabled={['define', 'artifacts']}
              tabs={solutionTabs}
            />
          </div>
        </div>
        <div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <SolutionRegistrationInput
              control={control}
              formState={formState}
              register={register}
            />
            <div className="w-full flex flex-row p-4 bg-gray-100">
              {isRegistering ? (
                <div className="w-full flex flex-row p-6 justify-center">
                  <LoadingIndicator />
                </div>
              ) : (
                <Button
                  aria-label="submit form"
                  disabled={
                    Object.keys(formState.errors).length > 0 ||
                    notFullyFilledOut
                  }
                  role="button"
                  type="submit"
                >
                  Register &amp; Save
                </Button>
              )}
            </div>
          </form>
        </div>
      </Container>
    </Page>
  );
};
